module.exports = __webpack_public_path__ + "c71cf2072712ab8c7b68ab63b065fa41.jpg";